<template>
  <div class="callme_total_wrap hidden-xs-only">
    <!-- <div class="callme_top_wrap"></div> -->
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="items_wrap">
          <div class="item_tit">关于三益</div>
          <div class="item_options">
            <span @click="handleToRouter('/home')">首页</span>
            <span @click="handleToRouter('/production/1')">热门机构</span>
            <span @click="handleToRouter('/fivenav/1')">在线预约</span>
            <span @click="handleToRouter('/home')">加入我们</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">内容中心</div>
          <div class="item_options">
            <span @click="handleToRouter('/fournav/1')">最新资讯</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">联系我们</div>
          <div class="item_options">
            <el-menu
              :default-active="activeIndex"
              class="el_menu_demo"
              mode="horizontal"
              background-color="#21282D"
              text-color="#8F9095"
              active-text-color="#8F9095"
              @select="handleSelect"
            >
              <el-menu-item index="1" class="el_menu_item">成都</el-menu-item>
              <el-menu-item index="2" class="el_menu_item">遂宁</el-menu-item>
              <el-menu-item index="3" class="el_menu_item">宜宾</el-menu-item>
              <!-- <el-menu-item index="4" class="el_menu_item">重庆</el-menu-item> -->
            </el-menu>
            <div class="massage_show">
              <p>{{ cityInfomation[showCity].phone }}</p>
              <p>{{ cityInfomation[showCity].eamil }}</p>
              <p>{{ cityInfomation[showCity].address }}</p>
            </div>
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down" style="margin-left: 120px">
          <div class="item_tit">关注我们</div>
          <div class="item_options">
            <img src="@/assets/img/guanzhu.png" style="width: 124px; height: 124px;" alt="" />
            <span style="text-align: center; margin-top: 15px;"
              >智达康公众号</span
            >
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down">
          <div class="item_tit">关注我们</div>
          <div class="item_options">
            <img src="@/assets/img/dyQrcode.png" style="width: 124px; height: 124px;" alt="" />
            <span style="text-align: center; margin-top: 15px;"
              >智达康抖音号</span
            >
          </div>
        </div>
      </div>
      <div class="navigate_wrap">
        <span>友情链接:</span>
        <a href="http://www.gov.cn/">中华人民共和国中央人民政府</a>
        <a href="http://www.miit.gov.cn/">中华人民共和国工业和信息化部</a>
        <a href="https://www.fmprc.gov.cn/chn/gxh/tyb/">中华人民共和国外交部</a>
        <a href="http://www.cinn.cn/">中国工业新闻网</a>
        <a href="http://www.cena.com.cn/">中国电子信息产业</a>
        <a href="http://www.cio360.net/">中国信息主管网</a>
        <p>
          Copyright ©2025 智达康 . All Rights Reserved . 
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      cityInfomation: [
        {
          phone: '028-61621836',
          eamil: '林先生',
          address: '四川省成都市新都区蓉都大道南一段602号',
        },
        {
          phone: '028-61621836',
          eamil: '林先生',
          address: '四川省成都市新都区蓉都大道南一段602号',
        },
        {
          phone: '028-61621836',
          eamil: '林先生',
          address: '四川省成都市新都区蓉都大道南一段602号',
        },
        {
          phone: '028-61621836',
          eamil: '林先生',
          address: '四川省成都市新都区蓉都大道南一段602号',
        },
      ],
      showCity: 0,
    }
  },
  methods: {
    handleSelect(index) {
      this.showCity = parseInt(index) - 1
    },
    handleToRouter(url) {
      this.$router.replace(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  margin-top: 80px;
  .callme_top_wrap {
    width: 100%;
    height: 300px;
    background: url('../../assets/img/callme.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .callme_bottom_wrap {
    width: 100%;
    background: #21282d;
    color: #fff;
    padding-top: 70px;
    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 60px;
      border-bottom: solid #363636 2px;
      .items_wrap {
        margin-right: 100px;
        .item_tit {
          font-size: 22px;
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 120px;
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16px;
            margin-top: 35px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300PX;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15px;
            width: 300PX;
            height: 80px;
            p {
              margin-top: 30px;
            }
          }
          img {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 40px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #fff;
        padding-right: 30px;
        font-size: 18px;
        margin-right: 0;
      }
      p {
        font-size: 16px;
        color: #4e5557;
      }
    }
  }
}
</style>